exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-container[data-v-550f15b9] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n.file-upload-label[data-v-550f15b9] {\n  margin-top: 10px;\n  text-align: left;\n  margin-bottom: 5px;\n}\n.file-upload-field[data-v-550f15b9] {\n  display: flex;\n  justify-content: left;\n}\n.buttons[data-v-550f15b9] {\n  display: flex;\n  justify-content: right;\n  text-align: right;\n  margin-top: 10px;\n}\n.buttons button[data-v-550f15b9] {\n  font-size: 15px;\n}\n", ""]);

// exports
